"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function required(value, required) {
    var isValid = !(value == null || value === "" || value.length === 0);
    return isValid;
}
exports.default = required;
